export default __webpack_public_path__ + "static/media/tutorial.7cc718d7.gif";